<nav class="pl-0 pt-3 navbar navbar-expand-sm" id="policy-actions">
    <div *ngIf="customerData?.firstName" class="welcome-text pl-3">Welcome
        {{ customerData?.firstName }} {{ customerData?.lastName }} !
    </div>
    <ul class="navbar-nav flex-row align-nav-items">
        <li class="nav-item nav-item-web" *ngIf="!errorMessage">
            <a (click)="onAddPolicyClick()"
               [ngClass]="{'nav-separator': policyDetails.length > 1}"
               class="nav-link">
                <img alt="Add Policy" src="../../assets/images/icons/add-policy.svg">Add Policy</a>
        </li>
        <li class="nav-item mobileIpad" *ngIf="!errorMessage">
            <a (click)="onAddPolicyClick()"
               [ngClass]="{'nav-separator': policyDetails.length > 1}"
               class="nav-link">
                <img alt="Add Policy" src="../../assets/images/icons/add-policy.svg">Add</a>
        </li>
        <li class="nav-item nav-item-web">
            <a (click)="enbaleRemovePolicy()" *ngIf="policyDetails.length > 1" class="nav-link">
                <img alt="Remove Policy" src="../../assets/images/icons/remove-policy.svg">Remove Policy</a>
        </li>

        <li class="nav-item nav-item mobileIpad">

            <a (click)="enbaleRemovePolicy()" *ngIf="policyDetails.length > 1" class="nav-link">
                <img alt="Remove Policy" src="../../assets/images/icons/remove-policy.svg">Remove</a>
        </li>
    </ul>
</nav>


<div class="mt-4" *ngIf="policyDetails?.length > 0">
    <div class="my-policies-heading mb-1 pl-2 pl-lg-0">
        <img alt="My Policies" height="16px" src="../../assets/images/icons/policy.svg">
        <span class="my-policies pl-2">My Policies</span>
    </div>
    <div class="section">
        <div *ngFor="let policy of policiesPerPage" class="summaryList">
            <div [(ngModel)]="selectedPolicy" btnRadioGroup class="">
                <div class="row">
                    <div class="col policy-primary-info">
                        <div class="font-weight-bold">
              <span containerClass="custom-container" placement="bottom" tooltip="View Policy Details"
                    tooltipClass="custom-tooltip">
                <span *ngFor="let policyTerms of policy.terms">
                <span (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'policy-details',policy.address.formattedAddress)"
                      *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm"
                      class="cursor-pointer policy-name primary-textcolor"
                      [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-darkBlue'">
                  {{ policy.lobType }}</span>
              </span>
                <span *ngFor="let policyTerms of policy.terms">
                <span *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm">
                  <span (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'policy-details',policy.address.formattedAddress)"
                        class="cursor-pointer pl-1 policy-name primary-textcolor"
                        [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-darkBlue'">
                    <strong>#{{ policy.policyNumber }}</strong>
                  </span>
                </span>
              </span>
              </span>
                            <span (click)="removePolicyModal.show(); enableRemove= false" *ngIf="enableRemove"
                                  btnRadio="{{policy.policyNumber}}"
                                  class="cursor-pointer">
                <img alt="Remove the policy" class="ml-2 mb-1" width="16px" height="16px"
                     src="../../assets/images/icons/Close.svg">
              </span>
                        </div>
                        <div class="formatted-address">
              <span *ngFor="let policyTerms of policy.terms">
                <span *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm"
                      [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-black'">
                  {{ policy.address.formattedAddress }}
              </span>
              </span>
                            <span
                                    (click)="getPolicyDetails(policy.policyNumber,'renewal')"
                                    *ngIf="displayRenewalOffer(policy)"
                                    class="badge badge-offers text-white cursor-pointer px-2 ml-2 mt-1 clearfix bshadow0 pbs position-absolute">
                <span class="icon-Group-3631"></span>PAY MY RENEWAL INVOICE
              </span>
                        </div>
                    </div>
                    <div class="float-right">
                        <div class="row">
                            <div class="col" [ngClass]="policy?.hasActions ? 'pr-0' : ''">
                                <div class="renewalAlert">
                  <span
                          (click)="getNotificationsForEachPolicy(defaultNotificationFilter, policy.policyNumber);"
                          [outsideClick]="true"
                          [popoverContext]="context" [popover]="popTemplate"
                          containerClass="customClass"
                          placement="bottom">
                    <span *ngIf="policy?.numUnreadNotifications > 0">
                      <img
                              alt="Notifications" class="bell-img cursor-pointer mb-2" height="14px"
                              src="../../assets/images/icons/bell_bent.svg">
                      <span class="img-rounded float-right text-center text-white rounded-circle">
                        {{ policy?.numUnreadNotifications }}
                      </span>
                    </span>
                    <span *ngIf="policy?.numUnreadNotifications === 0">
                      <img
                              alt="Notifications" class="bell-img cursor-pointer mb-2" height="14px"
                              src="../../assets/images/icons/notification.svg">
                    </span>
                </span>
                                </div>
                                <div class="action-alert-msg" *ngIf="policy?.hasActions">Action Required!</div>
                            </div>
                            <div class="float-right">
                                <div class="pl-3 pr-4">
                                    <div [matMenuTriggerFor]="menu">
                                        <button class="take-me-to-button primary-textcolor" mat-button>Take me to
                                        </button>
                                        <mat-icon class="material-icons" style="font-size: 18px">arrow_drop_down
                                        </mat-icon>
                                    </div>
                                    <mat-menu #menu="matMenu">
                                        <div id="links">
                                            <div *ngFor="let policyTerms of policy.terms">
                                                <div *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm">
                                                    <button (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'policy-details',policy.address.formattedAddress)"
                                                            mat-menu-item>
                                                        Details
                                                    </button>
                                                    <button (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'policy-documents',policy.address.formattedAddress)"
                                                            mat-menu-item>
                                                        Documents
                                                    </button>
                                                    <button (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'claims',policy.address.formattedAddress)"
                                                            mat-menu-item>
                                                        Claims
                                                    </button>
                                                    <button (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'payment',policy.address.formattedAddress)"
                                                            mat-menu-item>
                                                        Billing
                                                    </button>
                                                </div>
                                            </div>
                                        </div>
                                    </mat-menu>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col">
                        <div class="row mt-md-2 mt-0 padding-non-mobile">
                            <div class="col-md-5 col-12">
              <span *ngFor="let policyTerms of policy.terms">
                 <div *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm">
                   <div [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-black'">
                     Status: {{ policyTerms?.statusDisplay }}
                   </div>
                   <div [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-black'">
                     Effective:
                     <span> {{ policyTerms?.effectiveDate | date:'MM/dd/yyyy' }} -
                         {{ policyTerms?.expirationDate | date:'MM/dd/yyyy' }}
                     </span>
                   </div>
                   <div class="d-none d-md-block">
                     <a (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'claims/new-claim',policy.address.formattedAddress)"
                        class="cursor-pointer file-a-claim-button">
                       <img alt="claims" class="pr-1 cursor-pointer" height="14px"
                            src="../../assets/images/icons/claims-home.svg"/>
                       File a Claim
                     </a>
                   </div>
                 </div>
              </span>
                            </div>
                            <div class="col-md col-12">
                <span *ngFor="let policyTerms of policy.terms">
                <div *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm" class="">
                  <div [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-black'">
                    Annual Premium: {{
                          policyTerms?.billing.totalPremium |
                              currency:'USD':'symbol-narrow':'1.2-2'
                      }}
                  </div>
                  <div *ngIf="!policy.billing.canMakeOneTimePayment"
                       [ngClass]="(policyTerms?.status === termStatus.cancel || policyTerms?.status === termStatus.expire) ? 'color-disabled': 'color-black'">
                    <span *ngIf="policy?.billing?.currentAmountDueDisplay === 'No Payment Due' ||
                    policy?.billing?.currentAmountDueDisplay.includes('automatic')">
                      <img alt="Notifications" class="pr-1 mb-1" height="11px"
                           src="../../assets/images/icons/green-checkbox.svg">
                    </span>{{ policy?.billing?.currentAmountDueDisplay }}
                  </div>
                  <div *ngIf="policy.billing.canMakeOneTimePayment">
                    <span *ngIf="policy?.billing?.currentAmountDueDisplay === 'No Payment Due' ||
                    policy?.billing?.currentAmountDueDisplay.includes('automatic')">
                      <img alt="Notifications" class="pr-1 mb-1" height="11px"
                           src="../../assets/images/icons/green-checkbox.svg">
                    </span>{{ policy?.billing?.currentAmountDueDisplay }}
                  </div>
                </div>
                  <div class="row col-12">
                    <div class="d-block d-md-none">
                     <a (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'claims/new-claim',policy.address.formattedAddress)"
                        class="cursor-pointer file-a-claim-button pr-1">
                       <img alt="claims" class="cursor-pointer pr-1" height="13px"
                            src="../../assets/images/icons/claims-home.svg"/>
                       File a Claim
                     </a>
                    </div>
                    <div *ngIf="policyTerms.status !== termStatus.renewal && policyTerms?.validTerm"
                         class="pl-3 pl-md-0 make-a-payment-button">
                      <div *ngIf="policy.billing.canMakeOneTimePayment">
                        <a (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'payment/make-payment',policy.address.formattedAddress)"
                           class="cursor-pointer can-make-payment">
                          <span class="icon-Billing-n-Paymetn_gray blue-icon pr-1"></span>Make a Payment</a>
                      </div>
                      <div *ngIf="!policy.billing.canMakeOneTimePayment" class="disable-make-payment">
                        <a (click)="navigateToPolicyDashboard(policy.policyNumber,policyTerms.effectiveDate,policyTerms.expirationDate,'payment/make-payment',policy.address.formattedAddress)">
                          <span class="icon-Billing-n-Paymetn_gray gray-icon pr-1"></span>Make a Payment</a>
                      </div>
                    </div>
                  </div>
                </span>
                            </div>
                        </div>
                    </div>
                    <div class="pr-4 float-right">
                        <div class="row float-right cursor-pointer expanded-section-icon">
                            <div class="pr-4" *ngIf="policy.usaaPolicy">
                                <a target="_blank" href="https://www.usaa.com/" class="usaa">Back to USAA.com</a>
                            </div>
                            <div (click)="toggleAdditionalInfo(policy.policyNumber)">
                                <i *ngIf="shouldHideAdditionalInfo(policy.policyNumber)"
                                   class="pt-1 toggle-icon icon-accordion_closed"></i>
                                <i *ngIf="!shouldHideAdditionalInfo(policy.policyNumber)"
                                   class="pt-1 toggle-icon icon-accordion-open"></i>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Expanded grid starts here -->
                <div [collapse]="shouldHideAdditionalInfo(policy.policyNumber)" class="row policy-expanded-section">
                    <!-- Mailing Address-->
                    <div class="mailing-address">
                        <div *ngIf="policy.division === 'SPECIALTY'">
                            <div class="glyph fs1 footer-tag">
                                <div class="clearfix bshadow0 pbs">
                                    <span class="icon-noun_915590_cc"></span>
                                    <span (click)="getPolicyDetails(policy.policyNumber,'address')"
                                          class="strong address-tag ml-2 cursor-pointer">
                    Tower Hill Specialty Mailing Address
                  </span>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="policy.division !== 'SPECIALTY'">
                            <div class="glyph fs1 footer-tag">
                                <div class="clearfix bshadow0 pbs">
                                    <span class="icon-Group-3666"></span>
                                    <span (click)="getPolicyDetails(policy.policyNumber,'address')"
                                          class="strong address-tag ml-2 cursor-pointer">
                    Tower Hill Insurance Mailing Address
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Agency Information -->
                    <div class="">
                        <div *ngIf="policy?.agency">
                            <div class="glyph fs1 footer-tag mt-2">
                                <div class="clearfix bshadow0 pbs">
                                    <span class="icon-Agent"></span>
                                    <span (click)="getPolicyDetails(policy.policyNumber,'address')" class="ml-2">
                    Your Agency: <span class="ml-2">{{ policy?.agency?.name }}</span>
                    <span *ngIf="policy?.agency?.phone != '' && policy?.agency?.phone != null">
                      |  {{ policy.agency?.phone }}
                    </span>
                  </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!--Expanded grid ends here -->
                <div class="row">
                    <!--Notification Popup starts here -->
                    <ng-template #popTemplate class="notificatioWidth" id="notificationsPopups" let-message="message">
                        <app-notifications
                                (filterNotifications)="filterNotifications($event)"
                                (showWarningModal)="showWarningModal($event)"
                                [notifications]="notifications"
                                [policy]="policy"
                                [notificationLocation]="'home-page'"
                                [showFiltersPanel]="showFiltersPanel"
                                [showNotificationsPanel]="showNotificationsPanel">
                        </app-notifications>
                    </ng-template>
                    <!--Notification Popup Ends here-->
                </div>
            </div>
        </div>
    </div>
    <div class="coverage-warning-verbiage">
        <small class="d-block pt-3">Important: The information on this screen does not and is not
            intended to evidence insurance coverage. To verify
            coverage, please refer to your policy.
        </small>
    </div>
    <div class="claims-policies-list-paginator mt-3">
        <mat-paginator
                (page)="pageChanged($event)"
                [hidden]="hidePagination"
                [length]="resultsLength"
                [pageSizeOptions]="pageSizeOptions"
                [pageSize]="defaultPageSize"
                showFirstLastButtons>
        </mat-paginator>
    </div>
</div>

<p-dialog [(visible)]="openNotificationWarningModal" [modal]="true">
    <p-header>
        Warning
    </p-header>
    {{ modalMessage }}
    <p-footer class="text-center alert-box">
        <button (click)="openNotificationWarningModal=false; stopEventPropagation($event)"
                class="btn btn-primary footer-btn"
                style="width: auto !important; font-size: 1rem;" type="button">Cancel
        </button>
        <button (click)="openNotificationWarningModal=false; onModalConfirmClick($event)"
                class="btn btn-primary footer-btn"
                style="width: auto !important; font-size: 1rem;" type="button">
            OK
        </button>
    </p-footer>
</p-dialog>

<div #addPolicyModal="bs-modal" [ngClass]="{'notifs-preferences': showNotificationManager}" bsModal
     class="modal fade add-policy mx-auto my-0">
    <div class="policy-registration modal-dialog m-0">
        <div *ngIf="showPolicyDetails" class="registration-body modal-content">
            <form [formGroup]="addPolicyForm">
                <div class="create-account-header mt-3 mb-4 pb-2 text-center primary-textcolor">
                    <img alt="Add Policy" height="40px" src="../../assets/images/icons/add_policy.svg" width="40px">&nbsp;&nbsp;
                    Add Policy
                </div>
                <div>
                    <div class="form-group mb-4">
                        <input class="form-control icon-policy icon-addon" formControlName="policyNum" maxlength="10"
                               name="policyNum"
                               oninput="this.value=this.value.toUpperCase()" placeholder="Policy Number" type="text">
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['policyNum'].hasError('required')"
                             class="text-danger">Policy
                            Number is required
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['policyNum'].hasError('pattern')"
                             class="text-danger">Policy
                            Number should be Alphanumeric
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['policyNum'].hasError('minlength')"
                             class="text-danger">Policy
                            Number should be minimum 10 characters
                        </div>
                        <span [tooltip]="policyHelp" class="icon-help icon_helpnw" containerClass="custom-container"
                              placement="left"
                              tooltipClass="custom-tooltip"></span>
                    </div>
                    <div class="form-group mb-4">
                        <input class="form-control icon-agent icon-addon" formControlName="agencyCode" maxlength="6"
                               name="agencyCode"
                               oninput="this.value=this.value.toUpperCase()" placeholder="Agency Code" type="text">
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['agencyCode'].hasError('required')"
                             class="text-danger">Agency
                            Code is required
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['agencyCode'].hasError('pattern')"
                             class="text-danger">Agency
                            Code should be Numbers
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['agencyCode'].hasError('minlength')"
                             class="text-danger">Agency
                            Code should be minimum 4 characters
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['agencyCode'].hasError('maxlength')"
                             class="text-danger">Agency
                            Code can be maximum 6 characters
                        </div>
                        <span [tooltip]="agentHelp" class="icon-help icon_helpnw" containerClass="custom-container"
                              placement="left"
                              tooltipClass="custom-tooltip"></span>
                    </div>
                    <div class="form-group mb-4">
                        <input class="form-control icon-location icon-addon" formControlName="zipCode" maxlength="5"
                               name="zipCode"
                               placeholder="ZIP Code" type="text">
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['zipCode'].hasError('required')"
                             class="text-danger">ZIP
                            Code is required
                        </div>
                        <div *ngIf="addPolicyFormSubmitted && addPolicyForm.controls['zipCode'].hasError('pattern')"
                             class="text-danger">ZIP
                            Code should be Numeric and 5 characters
                        </div>
                        <span [tooltip]="zipHelp" class="icon-help icon_helpnw" containerClass="custom-container"
                              placement="left"></span>
                    </div>
                    <p class="primary-textcolor">
                        You can find this information on the quote summary you received from your agent or on any policy
                        documents.
                    </p>
                    <div class="col-md-12 col-12 d-flex p-0 mb-4" id="linkToSamples">
                        <button (click)="samplePolicy.show()"
                                class="btn btn-link col-md icon-policy icon-addon col-6 text-left pl-5"
                                id="policy-sample"
                                type="button">Sample Policy
                        </button>
                        <button (click)="sampleInvoice.show()"
                                class="btn btn-link col-md icon-invoice icon-addon col-6 text-left pl-5 ml-4"
                                id="invoice-sample"
                                type="button">Sample Invoice
                        </button>
                    </div>
                </div>
                <div>
                    <button (click)="addPolicyForm.reset();addPolicyModal.hide();"
                            class="btn btn-primary mb-4 cancelBtn">Cancel
                    </button>
                    <button (click)="addPolicy()" class="btn btn-primary mb-4 ml-3 continueBtn" type="submit">Continue
                    </button>
                </div>
            </form>
        </div>
    </div>
</div>
<form #validateEmailForm="ngForm">
    <div #contactsManager="bs-modal" [config]="{backdrop: 'static'}" bsModal
         class="modal fade contacts-manager my-0 mx-auto">
        <div class="modal-dialog m-0" role="document">
            <div class="modal-content">
                <div class="create-account-header my-3 text-center primary-textcolor">
                    <img alt="Add Policy" height="40px" src="../../assets/images/icons/add-policy-new.svg" width="40px">&nbsp;&nbsp;
                    <span *ngIf="firstLogin !=false">Add Policy</span>
                    <span *ngIf="firstLogin ==false">Welcome to our Customer Portal</span>
                </div>
                <h6 *ngIf="firstLogin == false" class="text-center primary-textcolor pb-2">Please confirm your contact
                    information.
                </h6>
                <h6 *ngIf="firstLogin != false" class="text-center primary-textcolor pb-2">Contact information
                    found.</h6>
                <p class="text-center py-3 info-banner px-3 px-md-0 text-white">
                    <b>Note:</b> Contact information selected here will apply to ALL policies</p>
                <p>To ensure that we have your current contact information, please confirm the information below.</p>
                <p *ngIf="emailExist != false" class="email-selector">
                    <b>Please select your preferred email:</b>
                </p>
                <p *ngIf="emailExist == false" class="email-selector">
                    <b>Please enter email:</b>
                </p>
                <div class="row bg-fill mx-0 p-3 email-options">
                    <div [ngClass]="newEmailId ? 'col-md-6 col-12 pr-0' : 'col-12'">
                        <div *ngIf="emailExist == true" class="form-check pb-3 pb-md-0">
                            <input (change)="updateEmailNotification(existingEmailId)"
                                   [checked]="notificationEmail == existingEmailId" [value]="existingEmailId"
                                   class="form-check-input"
                                   id="existingEmail"
                                   name="email" type="radio">
                            <label class="pl-3 form-check-label d-block ml-2">{{ existingEmailId }}</label>
                        </div>
                        <div *ngIf="emailExist == false">
                            <input #userentermail="ngModel" (keyup)="clearErrorMsg()" [(ngModel)]="userEnterEmail"
                                   class="form-control"
                                   id="userentermail" maxlength="128" name="userentermail"
                                   pattern="^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?)*$"
                                   placeholder="Enter email"
                                   required>
                            <div *ngIf="userentermail?.errors">
                                <small *ngIf="(userentermail.dirty || userentermail.touched) && !userentermail?.errors?.pattern"
                                       class="text-danger">Email
                                    is required
                                </small>
                                <small *ngIf="userentermail?.errors?.pattern" class="text-danger">Please enter a valid
                                    e-mail address
                                </small>
                            </div>
                            <small *ngIf="emailErrorMsg != null" class="text-danger">{{ emailErrorMsg }}</small>
                        </div>
                    </div>
                    <div *ngIf="newEmailId" class="col-md-6 col-12 pr-0">
                        <div class="form-check pb-3 pb-md-0">
                            <input (change)="updateEmailNotification(newEmailId)"
                                   [checked]="notificationEmail == newEmailId" [value]="newEmailId"
                                   class="form-check-input"
                                   id="newEmail"
                                   name="email" type="radio">
                            <label class="pl-3 form-check-label d-block ml-2">{{ newEmailId }}</label>
                        </div>
                    </div>
                </div>

                <p *ngIf="mobileContacts.length>0 || newMobileContacts.length>0" class="pt-2">Please select up to four
                    phone
                    numbers that will be applied to your associated policies. If you choose to provide
                    four phone numbers at least one must be a mobile number. </p>
                <div *ngIf="mobileContacts.length>0 || newMobileContacts.length>0" class="row bg-fill mx-0 p-3 mb-3">
                    <div *ngIf="mobileContacts.length>0" class="col-md col-12 pr-0">
                        <p *ngIf="firstLogin == false" class="primary-textcolor">Contact information</p>
                        <p *ngIf="firstLogin != false" class="primary-textcolor">
                            <b>Existing</b> contact information</p>
                        <div *ngFor="let mobile of mobileContacts; let i= index" class="col-12 p-0">
                            <div>
                                <input (change)="updateSmsNotification(existingPhone[i],mobile,i,'new')"
                                       [(ngModel)]="existingPhone[i]" class="type-selector"
                                       name="existingMobile{{mobile.phoneNo}}"
                                       type="checkbox">
                                <label class="pl-2">{{ mobile.phoneNo | phoneNo }}
                                    <span> ( {{ mobile.phoneType }} ) </span>
                                </label>
                            </div>
                        </div>
                    </div>
                    <div *ngIf="firstLogin != false && newMobileContacts.length>0" class="col-md col-12 pr-0">
                        <p class="primary-textcolor">
                            <b>New</b> contact information</p>
                        <div *ngFor="let mobile of newMobileContacts; let i= index" class="col-12 p-0">
                            <input (change)="updateSmsNotification(newPhone[i],mobile,i,'existing')"
                                   [(ngModel)]="newPhone[i]" name="newMobile{{mobile.phoneNo}}"
                                   type="checkbox">
                            <label class="pl-2">{{ mobile.phoneNo | phoneNo }}
                                <span> ( {{ mobile.phoneType }} ) </span>
                            </label>

                        </div>
                    </div>
                </div>
                <div *ngIf="newMobileContacts.length==0 && mobileContacts.length == 0">
                    <div class="col-xl-12 col-md-12 pl-0" style="margin-top:3% !important;overflow: hidden;">
                        <input #userenterphone="ngModel" (keyup)="clearErrorMsg()"
                               (ngModelChange)="userEnterPhone=$event"
                               [ngModel]="userEnterPhone | phoneNo" class="form-control float-left" id="userenterphone"
                               maxlength="12"
                               name="userenterphone" oncopy="return false" onpaste="return false"
                               pattern="^\d{3}[\-]\d{3}[\-]\d{4}$"
                               placeholder="Enter Phone Number" required style="width:55% !important">
                        <select #phonetype="ngModel" [(ngModel)]="selectPhoneType"
                                class="form-control float-left" id="phonetype" name="phonetype" required
                                style="width:30% !important">
                            <option selected value="">Select Type</option>
                            <option value="Mobile">Mobile</option>
                            <option value="Home">Home</option>
                            <option value="Work">Work</option>
                        </select>
                    </div>
                    <div *ngIf="userenterphone?.errors" class="col-xl-12 col-md-12">
                        <small *ngIf="(userenterphone.dirty || userenterphone.touched) && !userenterphone?.errors?.pattern"
                               class="text-danger">Phone
                            Number is required
                        </small>
                        <small *ngIf="userenterphone?.errors?.pattern" class="text-danger">Please enter a valid Phone
                            Number
                        </small>
                    </div>
                    <div>
                        <div *ngIf="phonetype?.errors" class="col-xl-12 col-md-12">
                            <small *ngIf="phonetype.dirty || phonetype.touched" class="text-danger">Phone Type is
                                required
                            </small>
                        </div>
                    </div>
                </div>
                <small class="py-2 px-0">You can edit this information later from your profile page.</small>
                <small *ngIf="phoneErrorMsg != null" class="text-danger">{{ phoneErrorMsg }}</small>
                <small *ngIf="phones.length>4" class="text-danger">Please select maximum four contact numbers</small>
                <small *ngIf="(phones.length == 4 && mobileType.length == 0)" class="text-danger">If you choose to
                    provide four
                    phone numbers, at least one must be a mobile number.
                </small>
                <small *ngIf="duplicatePhones != 0" class="text-danger">Duplicate phone numbers (
                    <span *ngFor="let duplicatenos of duplicatePhoneNumber; let i= index">{{ duplicatenos | phoneNo }}
                        <span *ngIf="duplicatePhoneNumber.length-1 != i">, </span>
          </span>) are chosen. Please provide unique phone numbers.
                </small>
                <div class="text-center mt-3">
                    <button (click)="contactsManager.hide();" [hidden]="firstLogin == false"
                            class="btn btn-primary mb-4 mr-3">
                        Cancel
                    </button>
                    <button (click)="updateNotificationDetails();"
                            *ngIf="firstLogin == false && (mobileType.length <= 1)"
                            [disabled]="phones.length>4 || (phones.length == 4 && mobileType.length == 0) || !validateEmailForm.form.valid || duplicatePhones != 0 "
                            class="btn btn-primary mb-4">Confirm
                    </button>
                    <button (click)="validateEmail();" *ngIf="firstLogin == false && mobileType.length > 1"
                            [disabled]="phones.length>4 || (phones.length == 4 && mobileType.length == 0) || !validateEmailForm.form.valid  || duplicatePhones != 0 "
                            class="btn btn-primary mb-4">Confirm
                    </button>
                    <button (click)="validatePhoneType();" *ngIf="firstLogin != false"
                            [disabled]="phones.length>4 || (phones.length == 4 && mobileType.length == 0)|| !validateEmailForm.form.valid || duplicatePhones != 0"
                            class="btn btn-primary mb-4">Confirm
                    </button>
                </div>
            </div>
        </div>
    </div>
</form>

<!--Select Modal-->
<div #contactsTracker="bs-modal" [config]="{backdrop: 'static'}" bsModal
     class="modal fade phone-manager mx-auto my-0 bg-white">
    <div class="modal-dialog m-0" role="document">
        <div class="modal-content">
            <div class="create-account-header my-3 text-center  primary-textcolor">Select One</div>
            <p class="primary-textcolor text-center">Please select a mobile number to receive profile- and claims-
                related
                alerts:
            </p>
            <div class="row">
                <ul class="phone-numbers col-12">
                    <li *ngFor="let itemrow of mobileType; let i = index" class="row">
                        <div class="form-group pr-0 mb-4 col-10">
                            <input [value]="itemrow.phoneNo | phoneNo" class="form-control float-left" readonly>
                            <input class="form-control float-left type-selector" readonly value="Mobile">
                        </div>
                        <div class="col-2">
                            <input (change)="changeSelectOption(itemrow.phoneNo)"
                                   [checked]="itemrow.notification == 'Y'" name="selectMobileNotify"
                                   type="radio"
                                   value="itemrow.notification">
                        </div>

                    </li>
                </ul>
            </div>
            <div class="text-center">
                <button (click)="contactsTracker.hide();" [hidden]="firstLogin == false" class="btn btn-primary mb-4">
                    Cancel
                </button>
                <button (click)="contactsTracker.hide();updateNotificationDetails();" *ngIf="firstLogin == false"
                        class="btn btn-primary mb-4 ml-3">Continue
                </button>
                <button (click)="notifsManager.show();contactsTracker.hide();" *ngIf="firstLogin != false"
                        class="btn btn-primary mb-4 ml-3">Continue
                </button>
            </div>
        </div>
    </div>
</div>
<!--Security Question Modal-->
<div #securityTracker="bs-modal" [config]="{backdrop: 'static'}" bsModal
     class="modal fade security-manager my-0 mx-auto">
    <div class="modal-dialog m-0" role="document">
        <form #securityForm="ngForm">
            <div class="modal-content">
                <p class="mt-4">Please select a security question and provide an answer below. This will help us verify
                    your
                    identity should you
                    forget your password.</p>
                <select [(ngModel)]="securityId" class="mb-4 primary-textcolor pl-2" id="security-question"
                        name="securityQuestions"
                        required>
                    <option selected value="">Select a Question</option>
                    <option *ngFor="let item of securityQuestionList" [value]="item.id">{{ item.question }}</option>
                </select>
                <div class="secAnswer position-relative">
                    <input [(ngModel)]="securityAnswer" class="form-control pl-3" name="answer" placeholder="Answer"
                           required
                           type="{{type}}"/>
                    <span (click)="toggleShow()" [ngClass]="showPasswordField ? 'icon-hidepwd': 'icon-showpwd'"
                          class="icon-showpwd toggle-icon"></span>
                    <span [tooltip]="secqnHelp" class="icon-help icon_helpnw" containerClass="custom-container"
                          placement="left"
                          tooltipClass="custom-tooltip"></span>
                </div>
                <div class="d-flex justify-content-center align-items-center">
                    <button (click)="securityTracker.hide();contactsManager.show();"
                            [disabled]="!securityForm.form.valid "
                            class="btn btn-primary my-4 ml-3">Continue
                    </button>
                </div>
            </div>
        </form>
    </div>
</div>

<div #notifsManager="bs-modal" [config]="{backdrop: 'static'}" bsModal class="modal fade notifs-manager mx-auto my-0">
    <div class="modal-dialog m-0" role="document">
        <div class="modal-content">
            <div class="create-account-header my-3">Alert Preferences</div>
            <div class="row notifs-list-header pt-2 pb-2">
                <div class="col-md">
                    <div class="row">
                        <div class="offset-6 col-3 text-left"> Email</div>
                        <div class="col-3 text-left"> Text</div>
                    </div>
                </div>
                <div class="col-md d-none d-md-block">

                    <div class="row">
                        <div class="offset-md-6 col-md-3 text-left"> Email</div>
                        <div class="col-md-3 text-left"> Text</div>
                    </div>
                </div>
            </div>
            <div class="row notifs-list">

                <div class="col-md col-12">
                    <div class="row">
                        <div class="col-6 alert-headers">Policy Alerts<sup>&lowast;</sup></div>
                        <div class="col-3">

                            <label class="switch">
                                <input [(ngModel)]="notificationsAlerts.policy_alert.email"
                                       [checked]="notificationsAlerts.policy_alert.email" type="checkbox">
                                <span class="slider"></span>
                            </label>
                        </div>

                        <div class="col-3">
                            <label class="switch">
                                <input [(ngModel)]="notificationsAlerts.policy_alert.text"
                                       [checked]="notificationsAlerts.policy_alert.text"
                                       type="checkbox">
                                <span class="slider"></span>
                            </label>
                        </div>
                        <div class="notif-desc col-12 pb-3">You'll receive alerts related to new policy documents,
                            policy
                            expiration, policy renewal and payment reminders
                        </div>
                    </div>
                </div>
                <div class="col-md col-12">
                    <div class="row">
                        <div class="col-6 alert-headers">Claims Alerts</div>
                        <div class="col-3">

                            <label class="switch">
                                <input [(ngModel)]="notificationsAlerts.claim_alert.email" type="checkbox">
                                <span class="slider"></span>
                            </label>
                        </div>

                        <div class="col-3">
                            <label [ngClass]="optOutSmsAlert ? 'switch-disable': ''" class="switch">
                                <input (change)="checkForTextAlertConditions($event)"
                                       [(ngModel)]="notificationsAlerts.claim_alert.text"
                                       [disabled]="optOutSmsAlert"
                                       type="checkbox">
                                <span class="slider"></span>
                            </label>
                        </div>
                        <div class="notif-desc col-12 pb-3">You'll receive alerts related to claims</div>
                    </div>
                </div>
            </div>
            <p class="info-text">
                <sup>&lowast;</sup> Policy alerts are mandatory
                <br>Enjoy the convenience of receiving the latest updates on your claims and policies on your mobile
                phone.
                Message & data rates may apply. Message frequency varies by account and preferences. Reply STOP to
                cancel or
                HELP for assistance.
            </p>
            <div class="text-center">
                <button (click)="notifsManager.hide();" [hidden]="firstLogin == false" class="btn btn-primary mb-4">
                    Cancel
                </button>
                <button (click)="notifsManager.hide();updateNotificationDetails();" class="btn btn-primary mb-4 ml-3">
                    Confirm
                </button>
            </div>
        </div>
    </div>
</div>

<div #removePolicyModal="bs-modal" [config]="{backdrop: 'static'}" bsModal
     class="modal fade remove-policy my-0 mx-auto">
    <h4 class="primary-textcolor text-center">Remove Policy?</h4>
    <p>Are you sure you want to remove policy
        <span class="primary-textcolor">
      <strong>{{ selectedPolicy }}</strong>?</span>
    </p>
    <p>Removing a policy from your account will not change the policy status.</p>
    <p>If you need to cancel the policy, please contact your agent or call Customer Service at
        <span class="primary-textcolor">{{ contactInfo?.customerCarePhone }}.</span>
    </p>
    <div>
        <button (click)="removePolicyModal.hide()" class="btn btn-primary mb-0 mb-lg-4" id="retainPolicy">No, Keep
            Policy
        </button>
        <button (click)="removePolicy()" class="btn btn-primary mb-0 mb-lg-4 ml-3">Yes, Remove Policy</button>
    </div>
</div>

<!--Sample Policy -->
<div #samplePolicy="bs-modal" [config]="{backdrop: 'static'}" bsModal class="modal fade sample-docs my-0 mx-auto">
    <div class="modal-dialog modal-lg-custom mt-2">
        <div class="modal-content">
            <span (click)="samplePolicy.hide();" btnRadio="samplePolicy" class="icon-close sample-delete"></span>
            <img alt="sample policy" class="sampleImg" src="../../../assets/images/bg/sample-policy.PNG">

        </div>
    </div>
</div>


<!--Sample Invoice-->
<div #sampleInvoice="bs-modal" [config]="{backdrop: 'static'}" bsModal class="modal fade sample-docs my-0 mx-auto">
    <div class="modal-dialog modal-lg-custom ">
        <div class="modal-content">
            <span (click)="sampleInvoice.hide();" btnRadio="samplePolicy" class="icon-close sample-delete"></span>
            <img alt="sample invoice" class="sampleImg" src="../../../assets/images/bg/sample-invoice.PNG">
        </div>
    </div>
</div>


<!--Address popup-->
<div #addressModal="bs-modal" [config]="{backdrop: 'static'}" bsModal class="modal fade address-popup-body"
     id="addressModal"
     role="dialog">
    <div class="modal-dialog modal-lg-custom addressmodal_popup">
        <div class="modal-content p-2 w-70">
            <div class="modal-body address-body">
                <div (click)="addressModal.hide();" btnRadio="{{policyData?.policyNumber}}"
                     class="glyph fs1 iconClose cursor-pointer position-absolute">
                    <div class="clearfix bshadow0 pbs">
            <span class="icon-Group-3621">
              <span class="path1"></span><span class="path2"></span><span class="path3"></span>
            </span>
                    </div>
                </div>
                <div class="mailingAddress col pb-0 px-0">
                    <h4 class="address-title primary-textcolor">You can send payment checks to: </h4>
                    <div *ngIf="policyData?.division !== 'SPECIALTY'">
                        <address class="row">
                            <div class="col-md-6 col-12 col-lg-6">
                                <strong>Tower Hill Insurance Lockbox Address:</strong>
                                <br> TOWER HILL INSURANCE
                                <br> PO BOX 947001
                                <br> ATLANTA, GA 30394-7001
                                <br>
                                <br>
                            </div>
                            <div class="col-md-6 col-12 col-lg-6">
                                <strong>Overnight payments should be sent to:</strong>
                                <br> Tower Hill Insurance Group
                                <br> Lockbox Services Lockbox Number #0947001
                                <br> 3585 Atlanta Ave
                                <br> Hapeville, GA 30354
                            </div>
                        </address>
                    </div>
                    <div *ngIf="policyData?.division === 'SPECIALTY'">
                        <div *ngIf="!isAfterDate">
                            <address>
                                Tower Hill Specialty Lockbox Address:
                                <br> Dept # 3165
                                <br> Tower Hill Specialty, LLC
                                <br> PO Box 2252
                                <br> Birmingham, AL 35246-3165
                            </address>
                        </div>
                        <div *ngIf="isAfterDate">
                            <address class="row">
                                <div class="col-md-6 col-12 col-lg-6">
                                    <strong>Tower Hill Specialty Lockbox Address:</strong>
                                    <br> Dept # 1365
                                    <br> Tower Hill Specialty, LLC
                                    <br> PO Box 71365
                                    <br> Charlotte, NC 28272-1365
                                </div>
                                <div class="col-md-6 col-12 col-lg-6">
                                    <strong>Overnight payments should be sent to:</strong>
                                    <br> Deluxe
                                    <br> ATTN: Tower Hill Specialty 71365
                                    <br> 6125 Lakeview Road, Suite 800
                                    <br> Charlotte, NC 28269
                                </div>
                            </address>
                        </div>
                    </div>
                </div>
                <div *ngIf="policyData?.lobType=='Flood'" class="address-divider">

                    <div *ngIf="policyData?.division !=='SPECIALTY'">
                        <h4 class="address-title address-pad primary-textcolor">Flood Type Policy Contact Address and
                            Contact
                            Number</h4>
                        <address class="row">
                            <div class="col-md-6 col-12 col-lg-6">
                                <strong>Contact Number: 800.342.3407</strong>

                                <br>
                                <strong> Standard Mail:</strong>
                                <br> Tower Hill Insurance Group
                                <br> P.O. Box 865001
                                <br> Orlando, FL 32886-5001
                                <br>
                                <br>
                            </div>
                            <div class="col-md-6 col-12 col-lg-6">
                                <strong>Overnight Mail:</strong>
                                <br> Tower Hill Insurance Group
                                <br> Lockbox Services Lockbox Number 865001
                                <br> 11050 Lake Underhill Rd
                                <br> Orlando, FL 32825
                            </div>
                        </address>
                    </div>

                    <div *ngIf="policyData?.division === 'SPECIALTY'">
                        <h4 class="address-title address-pad primary-textcolor">Flood Type Policy Contact Address and
                            Contact
                            Number</h4>
                        <address>
                            Contact Number:
                            <strong>800.342.3407</strong>
                        </address>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<!--Address popup-->

<!-- TP48174 Modals - STARTS -->

<div #addMobileNumber1="bs-modal" bsModal class="modal fade add-mobile-number bg-white mx-auto my-0">
    <div class="modal-body pt-0">
        <button (click)="addMobileNumber1.hide();notificationsAlerts.claim_alert.text = false;notifsManager.show()"
                aria-label="Close" class="iconClose cursor-pointer p-0 m-0 border-0 bg-white"
                data-dismiss="modal"
                type="button">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img alt="Phone Number required"
                                                            src="../../assets/images/icons/phone.svg">Mobile Number
            Required</h4>
        <p class="px-4 text-center">A mobile number is required to enable text alerts</p>
        <button (click)="addMobileNumber1.hide();addMobileNumber2.show()" class="btn btn-primary">Add Mobile Number
        </button>
    </div>
</div>
<div #addMobileNumber2="bs-modal" bsModal class="modal fade add-mobile-number bg-white mx-auto my-0">
    <div class="modal-body pt-0">
        <button (click)="addMobileNumber2.hide();updatedMobileNumber = '';showAddMobileNumberError= '';notificationsAlerts.claim_alert.text = false;notifsManager.show()"
                aria-label="Close" class="iconClose cursor-pointer p-0 m-0 border-0 bg-white"
                data-dismiss="modal"
                type="button">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img alt="Add mobile number"
                                                            src="../../assets/images/icons/phone.svg">Add Mobile Number
        </h4>
        <div class="form-group">
            <input (ngModelChange)="updatedMobileNumber = $event" [ngModelOptions]="{standalone: true}"
                   [ngModel]="updatedMobileNumber | phoneNo" class="form-control "
                   maxlength="12"
                   placeholder="Mobile Number" type="text">
            <div *ngIf="showAddMobileNumberError" class="text-danger pt-2">
                {{ showAddMobileNumberError }}
            </div>
        </div>
        <button (click)="addMobileTypeNumber()" [disabled]="!updatedMobileNumber" class="btn btn-primary">Save</button>
    </div>
</div>
<div #addMobileNumber3="bs-modal" bsModal class="modal fade add-mobile-number bg-white mx-auto my-0">
    <div class="modal-body pt-0">
        <button (click)="addMobileNumber3.hide();notifsManager.show()" aria-label="Close"
                class="iconClose cursor-pointer p-0 m-0 border-0 bg-white"
                data-dismiss="modal"
                type="button">
            <div class="glyph fs1 position-absolute">
        <span class="icon-Close">
          <span class="path1"></span><span class="path2"></span><span class="path3"></span>
        </span>
            </div>
        </button>
        <h4 class="primary-textcolor text-center mb-4"><img alt="mobile number added"
                                                            src="../../assets/images/icons/phone.svg">Mobile Number
            Added</h4>
        <p class="px-4 text-center">Your mobile number has been saved and is now enrolled in Claims alerts.</p>
        <button (click)="addMobileNumber3.hide();notifsManager.show()" class="btn btn-primary">Continue</button>
    </div>
</div>

<subscriber-savings-agreement-modal
        (activeSSAModal)="activeSSAModal($event)"
        [policyList]="policyDetails">
</subscriber-savings-agreement-modal>

<app-go-digital-modal
        [activeSSAModal]="ssaModalActive"
        [policyList]="customerData">
</app-go-digital-modal>

<div *ngIf="errorMessage" class="text-center text-danger p-2">
  <span *ngIf="backendErrorMessage; else defaultError">{{ backendErrorMessage }}</span>
  <ng-template #defaultError>
    Apologies, something went wrong, and we are unable to display your account information. Please try again later.<br>
    If you need immediate assistance, please contact Customer Care at 800.342.3407.
  </ng-template>
</div>
<!-- TP48174 Modals - ENDS -->
<p class="footer-session text-center mt-4">Host: {{ serverHostName }} :: Time: {{ serverTime }} ::
    Job: {{ serverJobName }} - {{ buildNumber }}
    :: SessionId: {{ usersessionId }}</p>
